module.exports = __webpack_public_path__ + "media/hyper/fonts/unicons-f5dd903de4721de0781954ebfb30e0e7.svg";